import { history_table_header_cells } from "../../assets/data"
import HistoryHeaderCell from "./HistoryHeaderCell"

export default function HistoryHeader({isInTab}) {
 

    return <thead>
        <tr>
            {/* .filter(item => isInTab ? item.id !=1 : item) */}
            {/* if we are on tab and not on history page, remove the NG# and person name!!!  */}
            {history_table_header_cells && history_table_header_cells.filter(item => isInTab ? (item.id !=22 && item.id != 333) : item).map(item => (
                <th key={item.id} >
                    <HistoryHeaderCell item={item}/>
                </th>
            ))}
        </tr>
    </thead>
}